import React, { useState, useEffect } from 'react';
import { Empty, Divider, Skeleton, Tabs, Modal } from 'antd';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { Button, ResetButton } from '../../../components/Atom/Button';
import { PageHeader } from '../../../components/Atom/PageHeader';
import '../style.css';
import { useSelector } from 'react-redux';
import { USER_ROLES } from 'utils/constant';
import { checkUserPermissions } from 'utils/services';
import { useQuery } from 'react-query';
import http from '../../../utils/http';
import { EditBilling } from './editBilling';
import { EditSubscription } from './editSubscription';
const TabPane = Tabs.TabPane;

export const SubscriptionDetails = () => {
  const store = useSelector((state) => state.company.store);
  const [activeTab, setActiveTab] = useState('1');
  const [openBillingDetails, setOpenBillingDetails] = useState(false);
  const [openSubscriptionDetails, setOpenSubscriptionDetails] = useState(false);

  const getStore = async () => {
    const res = await http.get(`/stores/${store?._id}`);
    return res?.data?.data;
  };
  const { data, isLoading, refetch, isFetching } = useQuery('settings', getStore, {
    enabled: false,
    manual: true,
    initialData: store,
  });

  useEffect(() => {
    refetch();
  }, [store, refetch]);

  const subscription = data?.subscription;
  const billingDetails = data?.billingDetails;

  const handleUpdateStoreData = () => {
    refetch();
  };
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Subscription Settings',
      },
    ],
  };
  const generalInformation = [
    { label: 'Cancel Subscription on Past-Due Payment', value: subscription?.allow_past_due_cancel ? 'Allowed' : 'Not Allowed' },
    { label: 'Pause Subscription on Past-Due Payment', value: subscription?.allow_past_due_pause ? 'Allowed' : 'Not Allowed' },
    { label: 'Skip Subscription on Past-Due Payment', value: subscription?.allow_past_due_skip ? 'Allowed' : 'Not Allowed' },
    { label: 'Send Payment Link if Subscription Payment Fails', value: subscription?.send_payment_link_on_inactive ? 'Allowed' : 'Not Allowed' },
    { label: 'Send Subscription Payment Email', value: (subscription?.send_subscription_payment_email ?? true) ? 'Enabled' : 'Disabled' },
    { label: 'Number of Retries on Payment Failure', value: subscription?.allowed_retries },
    { label: 'Invoice Action on Subscription Payment Failure', value: subscription?.invoice_action },
    { label: 'Subscription Action on Payment Failure', value: subscription?.subscription_action },
  ];
  const billingInformation = [
    { label: 'Bank Name', value: billingDetails?.bankName || 'N/A' },
    { label: 'Bank Branch', value: billingDetails?.bankBranch || 'N/A' },
    { label: 'Account No', value: billingDetails?.accountNumber || 'N/A' },
    { label: 'IBAN No', value: billingDetails?.iban || 'N/A' },
    { label: 'SWIFT Code', value: billingDetails?.swiftCode || 'N/A' },
    { label: 'NTN No', value: billingDetails?.ntn || 'N/A' },
    { label: 'Sales Tax No', value: billingDetails?.salesTaxNumber || 'N/A' },
    { label: 'Address Details', value: billingDetails?.address || 'N/A' },
    { label: 'Email', value: billingDetails?.email || 'N/A' },
    { label: 'Phone Number', value: billingDetails?.phoneNumber || 'N/A' },
  ];
  const onTabChange = (e) => {
    setActiveTab(e);
  };
  const handleEditBillingDetails = () => {
    setOpenBillingDetails(!openBillingDetails);
  };
  const handleEditSubscriptionDetails = () => {
    setOpenSubscriptionDetails(!openSubscriptionDetails);
  };

  return (
    <>
      <div style={{ padding: '0px', width: '100%' }}>
        <div className='header-container p-4'>
          <div>
            <Breadcrumbs {...breadcrumbProps} />
          </div>
          <div className='headerPage mobileContainer'>
            <div>
              <PageHeader label={'Subscription Settings'} button={<ResetButton onClick={isFetching ? '' : refetch} loading={isFetching} />} />
            </div>
            <div className='flexStoreFields m-r-10 selectStore'>
              {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                <>
                  {activeTab === '1' && data?.subscription && (
                    <Button className='mr-4 button-theme rounded-lg' onClick={handleEditSubscriptionDetails}>
                      Update Subscription Settings
                    </Button>
                  )}
                  {activeTab === '2' && data?.billingDetails && (
                    <Button className='primaryBtn mr-4' onClick={handleEditBillingDetails}>
                      Update Billing Settings
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <br />
        <Tabs defaultActiveKey='1' onTabClick={onTabChange} style={{ width: '100%' }}>
          <TabPane key='1' tab={<span id='icon'>Subscription Settings</span>}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
              </div>
            ) : !data?.subscription ? (
              <div className='overflow-x-auto rounded-lg'>
                <div className='bg-white shadow ' style={{ width: '100%' }}>
                  <Empty style={{ padding: '50px' }} description={'No subscription settings found'}>
                    {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                      <Button className='button-theme rounded-lg' onClick={handleEditSubscriptionDetails}>
                        Add Subscription Settings
                      </Button>
                    )}
                  </Empty>
                </div>
              </div>
            ) : (
              <div className='overflow-x-auto rounded-lg'>
                <div className='bg-white ' style={{ width: '100%' }}>
                  <>
                    {window.innerWidth < 641 ? (
                      <div className='bg-[#FAFAFA] h-[54px] rounded-border p-[3.53%] pt-[5%] font-semibold'>Title & Detail</div>
                    ) : (
                      <>
                        <div className='flex bg-[#FAFAFA] h-[54px] rounded-border'>
                          <div className='m-[1%] pl-[1%] pt-[0.75%] font-semibold text-[#262626]'>Title</div>
                          <div className='m-[1%] ml-[29.7%] pt-[0.75%] font-semibold text-[#262626]'>Details</div>
                        </div>
                      </>
                    )}

                    {generalInformation?.map((obj, index) => (
                      <React.Fragment key={index}>
                        <div className='px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-[#262626]'>{obj?.label}</dt>
                          <dd className='text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden subscription-value'>{obj?.value}</dd>
                        </div>
                        <Divider style={{ marginTop: '-0px', marginBottom: '-0px', backgroundColor: '#F5F5F5' }} />
                      </React.Fragment>
                    ))}
                  </>
                </div>
              </div>
            )}
          </TabPane>
          <TabPane key='2' tab={<span id='icon'>Billing Settings</span>}>
            {isLoading ? (
              <div style={{ width: '100%' }}>
                <Skeleton.Input style={{ width: '100%', height: '860px' }} active={true} />
              </div>
            ) : !data?.billingDetails ? (
              <div className='overflow-x-auto rounded-lg'>
                <div className='bg-white shadow ' style={{ width: '100%' }}>
                  <Empty style={{ padding: '50px' }} description='No billing settings found'>
                    {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                      <Button className='button-theme rounded-lg' onClick={handleEditBillingDetails}>
                        Add Billing Settings
                      </Button>
                    )}
                  </Empty>
                </div>
              </div>
            ) : (
              <div className='overflow-x-auto rounded-lg'>
                <div className='bg-white ' style={{ width: '100%' }}>
                  <>
                    {window.innerWidth < 641 ? (
                      <div className='bg-[#FAFAFA] h-[54px] rounded-border p-[3.53%] pt-[5%] font-semibold'>Title & Detail</div>
                    ) : (
                      <>
                        <div className='flex bg-[#FAFAFA] h-[54px] rounded-border'>
                          <div className='m-[1%] pl-[1%] pt-[0.75%] font-semibold text-[#262626]'>Title</div>
                          <div className='m-[1%] ml-[29.7%] pt-[0.75%] font-semibold text-[#262626]'>Details</div>
                        </div>
                      </>
                    )}

                    {billingInformation?.map?.((obj, index) => (
                      <React.Fragment key={index}>
                        <div className='px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-[#262626]'>{obj?.label}</dt>
                          <dd className='text-sm text-[#262626] sm:mt-0 sm:col-span-2 overflow-hidden subscription-value'>{obj?.value}</dd>
                        </div>
                        <Divider style={{ marginTop: '-0px', marginBottom: '-0px', backgroundColor: '#F5F5F5' }} />
                      </React.Fragment>
                    ))}
                  </>
                </div>
              </div>
            )}
          </TabPane>
        </Tabs>
      </div>

      <Modal open={openSubscriptionDetails} width={window.innerWidth < 768 ? 320 : 500} onCancel={handleEditSubscriptionDetails} destroyOnClose footer={null}>
        <div className='exportModal'>
          <header className='font-semibold text-base mb-4'>{data?.subscription ? 'Update Subscription Settings' : 'Add Subscription Settings'}</header>
          <EditSubscription handleOpen={handleEditSubscriptionDetails} updateState={handleUpdateStoreData} store={data} />
        </div>
      </Modal>

      <Modal open={openBillingDetails} width={window.innerWidth < 768 ? 320 : 600} onCancel={handleEditBillingDetails} destroyOnClose footer={null}>
        <div className='exportModal'>
          <header className='font-semibold text-base mb-4'>Update Billing Settings</header>
          <EditBilling handleOpen={handleEditBillingDetails} updateState={handleUpdateStoreData} store={data} />
        </div>
      </Modal>
    </>
  );
};
